import { z } from 'zod'

// Single source of truth for the Chainalysis risk vocabulary. The REST schema
// (server/chainalysis.ts) derives its enum from this list, so a new tier can't drift
// between the type and the runtime validator.
export const RISK_LEVELS = ['Severe', 'High', 'Medium', 'Low'] as const
export type RiskLevel = (typeof RISK_LEVELS)[number] | null

// Boolean-only verdict; risk reasons stay server-side (legal). The schema is the
// single source of truth for the type, and the client validates the wire response
// against it (an unexpected shape then fails closed).
export const screenedAddressSchema = z.object({ isAuthorized: z.boolean() })
export type ScreenedAddress = z.infer<typeof screenedAddressSchema>

export const SCREENING_BLOCKED_MESSAGE = "This wallet can't be connected to the app."

// Distinct from a definitive block: the screen never returned a verdict (outage, timeout, or a
// forced-fresh screen reverted before it resolved). Fail-closed still stops the transaction, but the
// copy must not imply the wallet itself was rejected — it's a transient service issue, so it's retryable.
export const SCREENING_UNAVAILABLE_MESSAGE =
  'Wallet verification is temporarily unavailable. Please try again.'

export const SCREEN_ADDRESS_ROUTE = '/api/screen-address'
